<div id='plan' class="plans-body">

  <div class="animated delay-2s fadeIn">

    <ul class="margin-25px">
      <li>
        <div>
          <h4 class="color-red">Estabelecimento</h4>
          <p>{{ planDetail.EstabelecimentoNome }}</p>
        </div>
      </li>
    </ul>

    <ul class="margin-25px">
      <li>
        <div>
          <h4 class="color-red">Nome do plano</h4>
          <p>{{ planDetail.Nome }}</p>
        </div>
      </li>
    </ul>

    <ul class="margin-25px">
      <li>
        <div>
          <h4 class="color-red">Descrição</h4>
          <p>{{ planDetail.Descricao }}</p>
        </div>
      </li>
    </ul>

    <ul class="margin-25px">
      <li>
        <div>
          <h4 class="color-red">Beneficiado</h4>
        </div>

        <div class="margin-25px">
          <select [(ngModel)]="selectedBeneficiado">
            <option value="0">Selecione um beneficiado.</option>
            <option *ngFor="let dependent of dependents" [ngValue]="dependent.value">
              {{dependent.title}}
            </option>
          </select>
        </div>
      </li>
    </ul>

    <ul class="margin-25px">
      <li>
        <div>
          <h4 class="color-red">Pagamento</h4>
        </div>

        <select class="margin-25px" [(ngModel)]="selectedPaymentMethod">
          <option value="0">Selecione o cartão de credito.</option>
          <option *ngFor="let paymentMethod of paymentMethods" [ngValue]="paymentMethod.value">
            {{paymentMethod.title}}
          </option>
        </select>


        <div class="margin-25px">
          <input type="text" id="fname" placeholder="Digite o CVV." [(ngModel)]="cvv" maxlength="4">
        </div>

      </li>
    </ul>

    <ul class="margin-25px">
      <li>
        <div>
          <h4 class="color-red">Número de cobranças</h4>
          <span *ngFor="let detalhe of planDetail.Detalhes">
            <h4>{{ detalhe.Ciclos }}</h4>
          </span>
        </div>
      </li>
    </ul>

    <ul class="margin-25px">
      <li>
        <div>
          <h4 class="color-red">Datas e valores de cobrança</h4>
          <span *ngFor="let detalhe of planDetail.Detalhes">
            <span *ngFor="let dataValor of detalhe.DatasValoresPeriodicidadeManual">
              <p> {{ dataValor.Data | date: 'dd/MM/yyyy' }} - <span>{{ dataValor.Valor | currency:"R$" }}</span></p>
            </span>
          </span>
        </div>
      </li>
    </ul>
    
    <!-- <ul class="margin-25px">
      <li>
        <div>
          <h4 class="color-red">VALOR</h4>
            <h4>{{ planDetail.ValorTotal | currency:"R$" }}</h4>
        </div>
      </li>
    </ul> -->

  </div>

  <button (click)="contract()" class="confirma">
    Contratar
  </button>

</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/plan-detail/plan-detail.component.html